import type { VoidComponent } from "solid-js";
import { For, Show } from "solid-js";
import { InformativeModal } from "../../../components/modal/Modal";
import type { User } from "../../../state/user";
import type { Group } from "../../../state/group";
import { resolveFullName } from "../../../utils/userUtil";
import { isEmpty } from "lodash-es";
import { useTranslation } from "../../../state/i18n";
import Text from "../../../components/text/Text";
import type { Invite } from "../../../state/invite.ts";

type DeleteRoleInUseModalProps = {
  users: User[];
  groups: Group[];
  invites: Invite[];
};

const DeleteRoleInUseModal: VoidComponent<DeleteRoleInUseModalProps> = (props) => {
  const { t } = useTranslation();

  return (
    <InformativeModal
      title={t(($) => $.DELETE_ROLE_IN_USE_MODAL_TITLE)}
      description={t(($) => $.DELETE_ROLE_IN_USE_MODAL_DESCRIPTION)}
      inlineMessage={
        <div class="flex flex-col gap-5">
          <Show when={!isEmpty(props.users) || !isEmpty(props.invites)}>
            <div>
              {t(($) => $.DELETE_ROLE_IN_USE_MODAL_USERS, { count: props.users.length + props.invites.length })}:
              <ul class="ml-6 list-outside list-disc">
                <For each={props.users}>
                  {(user) => (
                    <li>
                      <Text as="p" text={resolveFullName(user)} truncate />
                    </li>
                  )}
                </For>

                <For each={props.invites}>
                  {(invite) => (
                    <li>
                      <Text as="p" text={invite.emailAddress} truncate />
                    </li>
                  )}
                </For>
              </ul>
            </div>
          </Show>

          <Show when={!isEmpty(props.groups)}>
            <div>
              {t(($) => $.DELETE_ROLE_IN_USE_MODAL_GROUPS, { count: props.groups.length })}:
              <ul class="ml-6 list-outside list-disc">
                <For each={props.groups}>
                  {(group) => (
                    <li>
                      <Text as="p" text={group.name} truncate />
                    </li>
                  )}
                </For>
              </ul>
            </div>
          </Show>
        </div>
      }
      confirmLabel={t(($) => $.DELETE_ROLE_IN_USE_MODAL_ACTIONS_CONFIRM)}
      closeAriaLabel={t(($) => $.CLOSE_ARIA)}
    />
  );
};

export default DeleteRoleInUseModal;
